import { render, staticRenderFns } from "./SideNavLinkButtonComponent.vue?vue&type=template&id=63d6d122&"
import script from "./SideNavLinkButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./SideNavLinkButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d6d122')) {
      api.createRecord('63d6d122', component.options)
    } else {
      api.reload('63d6d122', component.options)
    }
    module.hot.accept("./SideNavLinkButtonComponent.vue?vue&type=template&id=63d6d122&", function () {
      api.rerender('63d6d122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Applicant/SideNavLinkButtonComponent.vue"
export default component.exports